import { useAuth } from "./useAuth";
import { ROLE_PERMISSIONS, type Permission } from "@/lib/permissions";
import type { Role } from "@/types/common";

export function usePermissions() {
  const { user } = useAuth();
  const role = user?.role ?? "EMPLOYEE";

  const can = (permission: Permission): boolean => {
    return ROLE_PERMISSIONS[role]?.has(permission) ?? false;
  };

  const hasRole = (...roles: Role[]): boolean => {
    return roles.includes(role);
  };

  return { can, hasRole, role };
}
